/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { BOOTSTRAP_FAILURE, BOOTSTRAP_SUCCESS } from 'actions/app';
import { AUTH_SUCCESS, AUTH_FAILURE, AUTH_CLEAR } from 'actions/auth';

import {
  SHOW_SHORTLIST_BASKET,
  HIDE_SHORTLIST_BASKET,
  GET_SHORTLIST_REQUEST,
  GET_SHORTLIST_SUCCESS,
  GET_SHORTLIST_FAILURE,
  CREATE_SHORTLIST_REQUEST,
  CREATE_SHORTLIST_SUCCESS,
  CREATE_SHORTLIST_FAILURE,
  ADD_TALENT_SHORTLIST_REQUEST,
  ADD_TALENT_SHORTLIST_SUCCESS,
  ADD_TALENT_SHORTLIST_FAILURE,
  REMOVE_TALENT_SHORTLIST_REQUEST,
  REMOVE_TALENT_SHORTLIST_SUCCESS,
  REMOVE_TALENT_SHORTLIST_FAILURE,
} from 'actions/shortlist';

import {
  SEND_REQUESTS_REQUEST,
  SEND_REQUESTS_SUCCESS,
  SEND_REQUESTS_FAILURE,
} from 'actions/job';

const REQUEST = 'REQUEST';

const initialState = {
  visible: false,
  loading: true,
  likelist_id: null,
  requestlist_id: null,
  requests: {
    talent_count: 0,
    talents_by_skill: [],
  },
  likes: {
    talent_count: 0,
    talents_by_skill: [],
  },
};

/**
 * This is the profile reducer. It listens for actions and updates the profile state object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type, payload }) {
  switch (type) {
    case CREATE_SHORTLIST_REQUEST:
    case GET_SHORTLIST_REQUEST:
    case ADD_TALENT_SHORTLIST_REQUEST:
    case REMOVE_TALENT_SHORTLIST_REQUEST:
    case SEND_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case SHOW_SHORTLIST_BASKET:
      return {
        ...state,
        visible: true,
      };

    case HIDE_SHORTLIST_BASKET:
      return {
        ...state,
        visible: false,
      };

    case SEND_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case CREATE_SHORTLIST_SUCCESS:
    case GET_SHORTLIST_SUCCESS:
      var shortlistGroup = payload.type === REQUEST ? 'requests' : 'likes';

      return {
        ...state,
        loading: false,
        [shortlistGroup]: {
          talents_by_skill: payload.talents_by_skill,
          talent_count: payload.talent_count,
        },
      };

    case ADD_TALENT_SHORTLIST_SUCCESS:
    case REMOVE_TALENT_SHORTLIST_SUCCESS:
      // Since the Requests basket can be visible everywhere we need to
      // map the talents correct after an edit to request.
      if (payload.type === REQUEST) {
        var mergedLikeItems = state.likes.talents_by_skill.map(g => ({
          ...g,
          talents: g.talents.map(a => ({
            ...a,
            ...payload.updated_gallery_profiles.find(
              b => b.talent_id === a.talent_id
            ),
          })),
        }));

        return {
          ...state,
          loading: false,
          visible: true,
          requests: {
            talents_by_skill: payload.talents_by_skill,
            talent_count: payload.talent_count,
          },
          likes: {
            ...state.likes,
            talents_by_skill: mergedLikeItems, // Updated items from request.
          },
        };
      }

      return {
        ...state,
        loading: false,
        likes: {
          talents_by_skill: payload.talents_by_skill,
          talent_count: payload.talent_count,
        },
      };

    case BOOTSTRAP_SUCCESS:
      return {
        ...state,
        requestlist_id: payload.shortlists.requestlist_id,
        likelist_id: payload.shortlists.likelist_id,
        loading: false,
      };

    case AUTH_SUCCESS:
      return {
        ...state,
        requestlist_id: payload.profile.shortlists.requestlist_id,
        likelist_id: payload.profile.shortlists.likelist_id,
      };

    case CREATE_SHORTLIST_FAILURE:
    case GET_SHORTLIST_FAILURE:
    case ADD_TALENT_SHORTLIST_FAILURE:
    case REMOVE_TALENT_SHORTLIST_FAILURE:
    case SEND_REQUESTS_FAILURE:
    case BOOTSTRAP_FAILURE:
    case AUTH_FAILURE:
    case AUTH_CLEAR:
      return {
        ...state,
        loading: false,
        requestlist_id: state.requestlist_id,
        likelist_id: state.likelist_id,
      };

    default:
      return state;
  }
}
